const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });

export const RefundOrderList = ({ orders, value, onChange }) => {
  if (!orders.length) {
    return (
      <p data-testid="refund-request-no-orders" className="rounded-xl bg-white p-5 text-sm text-[#6E665E] ring-1 ring-[#EBE4DA]">
        There are no paid orders on your account yet. For anything else, email support@yourlifejourneysmatter.com.
      </p>
    );
  }
  return (
    <div>
      <p className="mb-2 text-sm font-medium text-[#2D2824]">Which order?</p>
      <div className="space-y-2" role="radiogroup">
        {orders.map((o) => {
          const disabled = o.already_requested;
          const active = value === o.order_number;
          return (
            <button
              key={o.order_number}
              type="button"
              role="radio"
              aria-checked={active}
              disabled={disabled}
              data-testid={`refund-order-${o.order_number}`}
              onClick={() => onChange(o.order_number)}
              className={`w-full rounded-xl border-2 p-4 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${active ? "border-[#E06D53] bg-[#FFF4F0]" : "border-[#EBE4DA] bg-white hover:border-[#F7C4B8]"}`}
            >
              <span className="flex flex-wrap items-baseline justify-between gap-2">
                <span className="font-medium text-[#2D2824]">{o.product_label}{o.target ? ` · ${o.target}` : ""}</span>
                <span className="font-semibold text-[#A84A32]">A${Number(o.amount).toFixed(2)}</span>
              </span>
              <span className="mt-1 block text-xs text-[#8A7F76]">
                Order {o.order_number} · {fmtDate(o.paid_at)} · {o.provider === "stripe" ? "Card" : "PayPal"}
                {!o.within_14_days && " · more than 14 days ago"}
                {disabled && " · refund already requested"}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
